// src/pages/Stocks/components/StockGrid/StockGrid.jsx
import React from 'react';
import StockCard from '../StockCard/StockCard';
import './StockGrid.css';

const StockGrid = ({ stocks, searchTerm }) => {
  if (stocks.length === 0) {
    return (
      <div className="no-stocks">
        <p>No stocks found {searchTerm && `for "${searchTerm}"`}</p>
      </div>
    );
  }

  return (
    <section className="stock-grid-section">
      <h2 className="grid-title">All Assets</h2>
      <div className="stock-grid">
        {stocks.map(stock => (
          <StockCard key={stock.id} stock={stock} />
        ))}
      </div>
    </section>
  );
};

export default StockGrid;